import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export async function getVCSocialMedia(vcId, config) {
    return httpUtils.get(`${env.API_VERSION}/vc-social-media/${vcId}`, config);
}

export async function createVCSocialMedia(data, config) {
    return httpUtils.post(`${env.API_VERSION}/vc-social-media`, data, config);
}

export async function bulkStoreVCSocialMedia(data, config) {
    return httpUtils.post(`${env.API_VERSION}/vc-social-media/bulk`, data, config);
}

export async function updateVCSocialMedia(id, data, config) {
    return httpUtils.put(`${env.API_VERSION}/vc-social-media/${id}`, data, config);
}

export async function deleteVCSocialMedia(id, config) {
    return httpUtils.delete(`${env.API_VERSION}/vc-social-media/${id}`, config);
}
